module.exports = __webpack_public_path__ + "static/media/Build.da23318c.png";